import { useSuspenseQuery } from "@tanstack/react-query"
import { DEFAULT_STALE_TIME } from "toptaal-shared"
import { getMe } from "../services/user"
import { userQueryKeys } from "../query-keys/users"
import { useEffect } from "react"
import { useAuthStore } from "../store"

export const useCurrentStudentSuspenseQuery = () => {
  const setUser = useAuthStore((state) => state.setUser)

  const query = useSuspenseQuery({
    queryKey: userQueryKeys.current(),
    queryFn: getMe,
    staleTime: DEFAULT_STALE_TIME,
  })

  useEffect(() => {
    if (query.isSuccess && query.data) {
      setUser(query.data)
    }
  }, [query.isSuccess, query.data, setUser])

  return query
}
